import { motion } from "framer-motion";

const BACKS = [
  "/assets/card-back-lune-sm.jpeg",
  "/assets/card-back-soleil-sm.jpeg",
  "/assets/card-back-4-sm.jpeg",
  "/assets/card-back-rose-sm.jpeg",
];

export const CardBack = ({ variant = 0 }) => (
  <div className="relative h-full w-full overflow-hidden rounded-2xl border border-gold/60 bg-parch shadow-card">
    <img src={BACKS[variant % BACKS.length]} alt="" className="absolute inset-0 h-full w-full object-cover" />
  </div>
);

export const TarotCard = ({ flipped, selected, onClick, disabled, children, testid, variant = 0, className = "" }) => (
  <div
    data-testid={testid}
    onClick={!disabled ? onClick : undefined}
    className={`select-none ${disabled ? "" : "cursor-pointer"} ${className}`}
    style={{ perspective: 1000 }}
  >
    <motion.div
      animate={{ rotateY: flipped ? 180 : 0, scale: selected ? 1.04 : 1 }}
      transition={{ duration: 0.7, ease: [0.4, 0, 0.2, 1] }}
      className="preserve-3d relative h-full w-full"
    >
      <div className="backface-hidden absolute inset-0">
        <CardBack variant={variant} />
      </div>
      <div className="backface-hidden absolute inset-0" style={{ transform: "rotateY(180deg)" }}>
        <div
          className={`h-full w-full overflow-hidden rounded-2xl bg-gradient-to-br from-[#FBE0E8] via-[#FDF4EE] to-[#F2CFDA] transition-shadow duration-300 ${
            selected ? "border-2 border-gold shadow-glow" : "border border-[#D97B8F]/40 shadow-card"
          }`}
        >
          <img
            src="/assets/mandala-arrow.jpeg"
            alt=""
            className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-[0.16]"
          />
          <img
            src="/assets/mandala-sun.jpeg"
            alt=""
            className="spin-slow pointer-events-none absolute -right-6 -top-6 h-20 w-20 rounded-full object-cover opacity-30"
          />
          <img
            src="/assets/mandala-sun.jpeg"
            alt=""
            className="spin-slow pointer-events-none absolute -bottom-7 -left-7 h-24 w-24 rounded-full object-cover opacity-25"
          />
          <div className="pointer-events-none absolute inset-1.5 rounded-xl border border-gold/40" />
          <div className="relative h-full w-full">{children}</div>
        </div>
      </div>
    </motion.div>
  </div>
);
